import { createContext, useMemo, useState } from "react";
import { createTheme} from "@mui/material";

// color tokens 



export const tokens = (mode) =>({
    ...(mode === "dark" 
        ?{
            primary: {
                100: "#d4d4d4",
                200: "#a8a8a8",
                300: "#7d7d7d",
                400: "#2b2b2b",
                500: "#262626",
                600: "#1e1e1e",
                700: "#171717",
                800: "#0f0f0f",
                900: "#080808"
            },
            dark: {
                100: "#40466e",
                200: "#9fa3b7",
                300: "#707492",
                400: "#cfd1db",
                500: "#10184a",
                600: "#0d133b",
                700: "#0a0e2c",
                800: "#060a1e",
                900: "#03050f"
            },
            white: {
                100: "#fcfcfd",
                200: "#f9f9fc",
                300: "#f6f7fa",
                400: "#f3f4f9",
                500: "#f0f1f7",
                600: "#c0c1c6",
                700: "#909194",
                800: "#606063",
                900: "#303031"
            },
            orange: {
                100: "#ffe5cd",
                200: "#ffcb9a",
                300: "#ffb168",
                400: "#ff9735",
                500: "#ff7d03",
                600: "#cc6402",
                700: "#994b02",
                800: "#663201",
                900: "#331901"
            },
            red: {
                100: "#ffd7cd",
                200: "#ffb09a",
                300: "#ff8868",
                400: "#ff6135",
                500: "#ff3903",
                600: "#cc2e02",
                700: "#992202",
                800: "#661701",
                900: "#330b01"
            },
            teal: {
                100: "#ceecd3",
                200: "#9dd9a8",
                300: "#6cc77c",
                400: "#3bb451",
                500: "#0aa125",
                600: "#08811e",
                700: "#066116",
                800: "#04400f",
                900: "#022007"
            },
            blue: {
                100: "#d6e6dc",
                200: "#accdb9",
                300: "#83b497",
                400: "#599b74",
                500: "#308251",
                600: "#266841",
                700: "#1d4e31",
                800: "#133420",
                900: "#0a1a10"
            },
            yellow: {
                100: "#fff3cdc0",
                200: "#ffe69c",
                300: "#ffda6a",
                400: "#ffcd39",
                500: "#ffc107",
                600: "#cc9a06",
                700: "#997404",
                800: "#664d03",
                900: "#332701"
            },
            newTeal: {
                100: "#cff4fc",
                200: "#9eeaf9",
                300: "#6edff6",
                400: "#3dd5f3",
                500: "#0dcaf0",
                600: "#0aa2c0",
                700: "#087990",
                800: "#055160",
                900: "#032830"
            },
            gray: {
                100: "#eff0f2",
                200: "#dee1e5",
                300: "#ced3d7",
                400: "#bdc4ca",
                500: "#adb5bd",
                600: "#8a9197",
                700: "#686d71",
                800: "#45484c",
                900: "#232426"
            },
            indigo: {
                100: "#cfe2ff",
                200: "#9ec5fe",
                300: "#6ea8fe",
                400: "#3d8bfd",
                500: "#0d6efd",
                600: "#0a58ca",
                700: "#084298",
                800: "#052c65",
                900: "#031633"
            },
            green: {
                100: "#d1e7dd",
                200: "#a3cfbb",
                300: "#75b798",
                400: "#479f76",
                500: "#198754",
                600: "#146c43",
                700: "#0f5132",
                800: "#0a3622",
                900: "#051b11"
            }
        }:{
            primary: {
                100: "#080808",
                200: "#0f0f0f",
                300: "#171717",
                400: "#1e1e1e",
                500: "#ffffff",
                600: "#515151",
                700: "#7d7d7d",
                800: "#a8a8a8",
                900: "#d4d4d4",
            },
            dark: {
                100: "#03050f",
                200: "#060a1e",
                300: "#fcfcfd",
                400: "#0d133b",
                500: "#10184a",
                600: "#40466e",
                700: "#707492",
                800: "#fcfcfd",
                900: "#cfd1db",
            },
            white: {
                100: "#303031",
                200: "#606063",
                300: "#909194",
                400: "#c0c1c6",
                500: "#f0f1f7",
                600: "#f3f4f9",
                700: "#909194",
                800: "#f9f9fc",
                900: "#fcfcfd",
            },
            orange: {
                100: "#331901",
                200: "#663201",
                300: "#994b02",
                400: "#cc6402",
                500: "#ff7d03",
                600: "#ff9735",
                700: "#ffb168",
                800: "#ffcb9a",
                900: "#ffe5cd",
            },
            red: {
                100: "#330b01",
                200: "#661701",
                300: "#992202",
                400: "#cc2e02",
                500: "#ff3903",
                600: "#ff6135",
                700: "#ff8868",
                800: "#ffb09a",
                900: "#ffd7cd",
            },
            teal: {
                100: "#022007",
                200: "#04400f",
                300: "#066116",
                400: "#08811e",
                500: "#0aa125",
                600: "#3bb451",
                700: "#6cc77c",
                800: "#9dd9a8",
                900: "#ceecd3",
            },
            blue: {
                100: "#0a1a10",
                200: "#133420",
                300: "#1d4e31",
                400: "#266841",
                500: "#308251",
                600: "#599b74",
                700: "#83b497",
                800: "#accdb9",
                900: "#d6e6dc",
            },
            yellow: {
                100: "#332701",
                200: "#664d03",
                300: "#997404",
                400: "#cc9a06",
                500: "#ffc107",
                600: "#ffcd39",
                700: "#ffda6a",
                800: "#ffe69c",
                900: "#fff3cd",
            },
            newTeal: {
                100: "#032830",
                200: "#055160",
                300: "#087990",
                400: "#0aa2c0",
                500: "#0dcaf0",
                600: "#3dd5f3",
                700: "#6edff6",
                800: "#9eeaf9",
                900: "#cff4fc",
            },
            gray: {
                100: "#232426",
                200: "#45484c",
                300: "#686d71",
                400: "#8a9197",
                500: "#adb5bd",
                600: "#bdc4ca",
                700: "#ced3d7",
                800: "#dee1e5",
                900: "#eff0f2",
            },
            indigo: {
                100: "#031633",
                200: "#052c65",
                300: "#084298",
                400: "#0a58ca",
                500: "#0d6efd",
                600: "#3d8bfd",
                700: "#6ea8fe",
                800: "#9ec5fe",
                900: "#cfe2ff",
            },
            green: {
                100: "#051b11",
                200: "#0a3622",
                300: "#0f5132",
                400: "#146c43",
                500: "#198754",
                600: "#479f76",
                700: "#75b798",
                800: "#a3cfbb",
                900: "#d1e7dd",
            }
        }
    )
    
});

export const themeSettings = (mode) => {
    const colors = tokens(mode);

    return{
        palette: {
            mode: mode,
            ...(mode === 'dark' 
                ? {
                    primary: {
                        main: colors.primary[100],
                    },
                    secondary: {
                        main: colors.orange[200],
                    },
                    neutral: {
                        dark: colors.dark[100],
                        main: colors.primary[100],
                        light: colors.white[100]
                    },
                    background: {
                        default: colors.dark[800]
                    }
                }:{
                    primary: {
                        main: colors.primary[100],
                    },
                    secondary: {
                        main: colors.orange[200],
                    },
                    neutral: {
                        dark: colors.dark[500],
                        main: colors.primary[500],
                        light: colors.white[100]
                    },
                    background: {
                        default: "#d9d9d9"
                    }
                }
            )
        },
        typography: {
            fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
            fontSize: 12,
            h1: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 40,
            },
            h2: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 35,
            },
            h3: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 25,
            },
            h4: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 22,
            },
            h5: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 15,
            },
            h6: {
                fontFamily: ["Sourse Sans Pro", "sans-serif"].join(","),
                fontSize: 12,
            },
        }
    };
};


export const ColorModeContext = createContext({
    toggleColoeMode: () => {}
});

export const useMode = () => {
    const [mode, setMode] = useState("light");

    const colorMode = useMemo(
        () => ({
            toggleColoeMode: () => setMode((prev) => (prev === "light" ? "dark" : "light")),
        }),[]
    );

    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

    return [theme, colorMode];
}